// @ts-nocheck
import React from 'react';
import { OrganizationProvider } from '../../../contexts/OrganizationContext';
import GalleryContent from './GalleryContent';

const GalleryPage: React.FC = () => {
  return (
    <OrganizationProvider>
      <GalleryContent />
    </OrganizationProvider>
  );
};

export default GalleryPage;